<template>
<div class="reseller-list">
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
    <!-- 自定义下拉区域内容 -->
    <template #pulling></template>       <!-- 下拉时：空 -->
    <template #loosing><van-loading type="spinner" size="24px" /></template>       <!-- 松手时：空 -->
    <template #loading>
      <!-- 只显示 loading 动画 -->
      <van-loading type="spinner" size="24px" />
    </template>
    <div class="container">
      <template v-if="showTitle == 1">
        <h1>{{ $t("reseller.title") }}</h1>
        <p>{{ $t("reseller.description") }}</p>
      </template>
        <div class="contacts-grid">
            <div v-for="member in userList" :key="member.userId" class="contact-card">
                <div class="avatar">
                    <img :src="member.icon" :alt="member.nickname" @click="skipUserInfo(member)">
                </div>
                <div class="contact-info">
                    <h2>{{ member.nickname }}</h2>
                    <p class="title">ID:{{ member.prettyNumber ? member.prettyNumber : member.userId }}</p>
                    <p class="title">{{ $t("reseller.onSale") }} <span>{{member.diamond > 10000 ? member.diamond : 10000}}</span></p>
                    <p class="title"> {{ $t("reseller.transaction").replace("{n}", member.receivePeopleNum > 20 ? member.receivePeopleNum : 20) }}</p>
                </div>
                <div class="social-links">
                    <a :href="'https://wa.me/' + member.whatsApp" class="whatsapp">
                        <img v-if="$i18n.locale == 'ar'" src="../../assets/reseller/icon_ar.png" alt="WhatsApp">
                        <img v-else src="../../assets/reseller/icon.png" alt="WhatsApp">
                    </a>
                </div>
            </div>
        </div>
    </div>
  </van-pull-refresh>
</div>
</template>

<script>
import axios from "axios";
export default {
  name: 'ResellerList',
  data() {
    return {
      userList:[],
      userInfo: [],
      showTitle:1,
      isLoading: false,
      count: 0,
    }
  },
  created() {
    // 1展示title  2隐藏  兼容ios
    const { showTitle: showTitleParam } = this.getURLParam();
    this.showTitle = (!showTitleParam || showTitleParam === '1') ? 1 : 2;
    //调用原生方法
    this.$completes.complete("getUserInfo");
    //原生调用h5方法
    window.getUserInfo = this.getUserInfo;
    window["getUserInfo"] = (data) => {
      this.getUserInfo(data);
    };
    // this.getUserInfo();
    this.judgeClient();
  },
  methods: {
    onRefresh() {
      this.getRecellerList();
    },
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      this.token = JSON.parse(data).token
      this.uid = JSON.parse(data).userId
      let langs = this.userInfo.lang.substring(0,2)
      this.langs = this.userInfo.lang.substring(0,2)
      let lang = this.userInfo.lang
      this.headers = {
          fid:  this.userInfo.fid,
          os:  this.userInfo.os || 1,
          lang: this.userInfo.lang,
          version:this.userInfo.version,
          deviceid:this.userInfo.deviceId,
        }
      //    this.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOemt6TWpJNCIsInh5eiI6IlEwWkRRakJCTURBdFJEYzJOaTAwTURZMkxUaEJRamd0UkVaR01rVXhSRFpCUWpjMSIsImV4cCI6MTk5MjQ5NDQ0N30.toInbRHaQKUfK73mTeDuSXyKmY-dEUZRiMKa_G7JNmw';
      // this.uid = '793228'; 
      // this.headers = {
      //     fid: '1001',
      //     os: 1,
      //     lang: 'zh-CN',
      //     version: '3.0',
      //     deviceid: 'CFCB0A00-D766-4066-8AB8-DFF2E1D6AB75',
      // }
      // let langs = 'ar'
      // this.langs = langs
      // let lang = langs
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr";
      } else if (langs == "id") {
          this.$i18n.locale = "id";
      } else if (langs == "ms") {
          this.$i18n.locale = "ms";
      } else {
        this.$i18n.locale = "en";
      }
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    document.title = this.$t("reseller.pageTitle");
      this.getRecellerList()
    },
    getURLParam() {
      const hash = window.location.hash; // 例如: "#/home?cfgId=79"
      // 提取 ? 开始的部分
      const queryStringMatch = hash.match(/\?.+/);
      if (queryStringMatch) {
        const search = queryStringMatch[0]; // "?cfgId=79"
        const params = new URLSearchParams(search);
        return Object.fromEntries(params.entries());
      }
      return {};
    },
    getRecellerList() {
      axios
        .get(this.$serviceIp +`api/trade/receller/recellerList?uid=${this.uid}&token=${this.token}`,{
            headers: this.headers
        })
        .then((response) => {
          if (response.data.code == 200) {
              this.userList = response.data.data;
          }
        }).catch(()=>{}).finally(()=>{
            this.isLoading = false;
        });
    },
    skipUserInfo(item) {
      let uid = item.userId;
      if (this.client == 'iOS') {
        window["webkit"].messageHandlers['skipUserInfo'].postMessage(JSON.stringify(uid));
      } else if (this.client == 'Android') {
        nativeJs["skipUserInfo"](JSON.stringify(uid));
      }
    },
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
  }
}
</script>

<style scoped>

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
html[lang="ar"] .reseller-list{
  direction: rtl;
}
html[lang="ar"] .title span::before{
  margin-left: 2px;
}
body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background: #F5F6F8;
    color: #ffffff;
    line-height: 1.47059;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
}

.reseller-list {
    min-height: 100vh;
    width: 100%;
    position: relative;
    overflow: hidden;
    font-family: 'Montserrat';
    /* background: #F5F6F8; */
}

/* 确保内容在背景之上 */
.container {
    position: relative;
    z-index: 2;
    padding: 28px;
    max-width: 100%;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.contacts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    gap: 20px;
    width: 100%;
    /* padding: 20px; */
    box-sizing: border-box;
}

/* 卡片样式更新 */
.contact-card {
    /* background: rgba(255, 255, 255, 0.25); */
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 24px;
    /* padding: 30px 36px; */
    display: flex;
    align-items: center;
    gap: 18px;
    /* border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1); */
    margin-bottom: 28px;
    width: 100%;
    min-width: 0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.contact-card:active {
    transform: scale(0.98);
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.avatar {
    width: 108px;
    height: 108px;
    border-radius: 54px;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
    position: relative;
    z-index: 2;
}

.image-container {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    position: relative;
    z-index: 2;
}

.contact-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
    flex: 1;
}

h2 {
    font-size: 28px !important;
    font-weight: 500;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: #262427;
}

.title {
    color: #AFA9B4;
    font-size: 24px !important;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    font-weight: 500;
}
.title span{
  font-size: 24px;
  color: #8131E7;
  font-weight: 500;
  margin-left: 8px;
  /* display: flex;
  align-items: center; */
}
.title span::before{
  display: inline-block;
  content: '';
  width: 28px;
  height: 28px;
  background: url('../../assets/reseller/zuan.png') no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-right: 2px;
}

/* 社交图标样式 */
.social-links {
    display: flex;
    gap: 24px;
    margin-left: auto;
    flex-shrink: 0;
}

.social-links a {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F0F2F5;
    border-radius: 50%;
    transition: all 0.2s ease;
    position: relative;
}

.social-links a:active {
    transform: scale(0.95);
    background: rgba(137, 132, 141, 0.1);
}

.social-links img {
    width: 64px;
    height: 64px;
}

/* 添加点击涟漪效果 */
.social-links a::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, transparent 70%);
    opacity: 0;
    transform: scale(2);
    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.social-links a:active::after {
    opacity: 1;
    transform: scale(0);
}

/* 标题样式 */
h1 {
    text-align: center;
    font-size: 48px !important;
    font-weight: 600;
    margin-bottom: 24px;
    color: #262427;
}

/* 添加说明文字样式 */
.container > p {
    text-align: center;
    font-size: 24px !important;
    color: #89848D;
    margin-bottom: 48px;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    opacity: 0.8;
}


/* 安全区域适配 */
@supports (padding: max(0px)) {
    .container {
        padding-left: max(15px, env(safe-area-inset-left));
        padding-right: max(15px, env(safe-area-inset-right));
        padding-bottom: max(15px, env(safe-area-inset-bottom));
    }
}

/* 移动端适配 */
@media (max-width: 390px) {
    .contact-card {
        /* padding: 15px 18px; */
        gap: 15px;
    }

    .avatar {
        width: 108px;
        height: 108px;
        border-radius: 96px;
    }

    h1 {
        font-size: 42px !important;
    }

    h2 {
        font-size: 28px !important;
    }

    .title {
        /* font-size: 21px !important; */
    }

    .social-links {
        gap: 16px;
    }

    .social-links a {
        width: 60px;
        height: 60px;
    }

    .social-links img {
        width: 64px;
        height: 64px;
    }

    .container > p {
        font-size: 24px !important;
        margin-bottom: 36px;
        padding: 0 20px;
    }
}

/* 优化移动端触摸体验 */
@media (hover: none) {
    .contact-card:hover {
        transform: none;
    }
    
    .social-links a:hover {
        transform: none;
    }

}

/* 确保在移动端的性能 */
@media (prefers-reduced-motion: reduce) {
    .contact-card,
    .social-links a,
    .floating-circles,
    .wave,
    .background-animation {
        transition: none;
    }
}

.image-container {
    width: 200px;
    height: 200px;
    background: #fff;
}

.team-member-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0;
    transition: opacity 0.3s;
}

.team-member-image.is-loaded {
    opacity: 1;
}


</style>

